import { memo, useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import GUIDELINE_RULES from 'constants/guidelineRules';
import Checkbox, { ICON_TYPES } from 'components/checkbox';
import Label from 'components/label';
import CampaignFormField from '../../../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';

const VideoDurationField = () => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.pages.campaigns,
    ...language.component.checkbox,
  };

  const VIDEO_DURATION_OPTIONS = [
    {
      label: GUIDELINE_RULES.GetOptionTranslationMap(
        GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.VIDEO_DURATION,
        GUIDELINE_RULE_DTO_ENUMS.VIDEO_DURATION_OPTIONS.TWOWENTY,
      ),
      value: GUIDELINE_RULE_DTO_ENUMS.VIDEO_DURATION_OPTIONS.TWOWENTY,
    },
    {
      label: GUIDELINE_RULES.GetOptionTranslationMap(
        GUIDELINE_RULE_DTO_ENUMS.GROUP_NAME.VIDEO_DURATION,
        GUIDELINE_RULE_DTO_ENUMS.VIDEO_DURATION_OPTIONS.THIRTY,
      ),
      value: GUIDELINE_RULE_DTO_ENUMS.VIDEO_DURATION_OPTIONS.THIRTY,
    },
  ];

  const {
    guidelineRuleFormMethods: { control, setValue },
  } = useContext(CampaignFormContext);
  const videoDurationValue = useWatch({
    control,
    name: 'VIDEO_DURATION.value',
  });

  return (
    <CampaignFormField
      wrapperClassName="!mt-[50px]"
      label={languageTexts.create_reels_form_video_duration}
      labelClassName="!text-[17px]"
    >
      {VIDEO_DURATION_OPTIONS.map((option, index) => {
        return (
          <div
            key={`video-duration-checkbox-${index}`}
            className="flex flex-row items-center"
          >
            <Checkbox
              className="py-[6px] select-none"
              textClassName="select-none"
              text={option.label}
              type={ICON_TYPES.CIRCLE}
              checked={option.value === videoDurationValue}
              onClick={() => setValue('VIDEO_DURATION.value', option.value)}
            />
            {option.value === GUIDELINE_RULE_DTO_ENUMS.VIDEO_DURATION_OPTIONS.THIRTY && (
              <div className="ml-2 content-center">
                <Label
                  className="py-[1px] px-[3px]"
                  textClassName="text-xs"
                  text={languageTexts.recommend}
                  labelColor="black"
                  textColor="white"
                />
              </div>
            )}
          </div>
        );
      })}
    </CampaignFormField>
  );
};

export default memo(VideoDurationField);
